<template>
  <el-dialog
    class="dialog"
    :title="detailTitle"
    :visible.sync="dialogVisible"
    width="65%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
    @close="closeFrom"
  >
    <el-form
      :model="ruleForm"
      ref="rForm"
      label-width="100px"
      class="ruleForm"
      ::rules="rules"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="审核结果："
            prop="auditSchedule"
            :rules="[{ required: true, message: '请选择审核意见' }]"
          >
            <el-radio-group
              v-model="ruleForm.auditSchedule"
              @change="auditScheduleChange"
            >
              <el-radio
                v-for="(item, i) in auditScheduleAttr"
                :key="i"
                :label="item.paramKey"
              >
                {{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="驳回原因："
            prop="auditContent"
            v-if="isUnPass"
            :rules="[{ required: true, message: '请输入驳回原因' }]"
          >
            <el-input
              type="textarea"
              placeholder="请输入驳回原因"
              :row="3"
              v-model="ruleForm.auditContent"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="短信通知："
            prop="isNotice"
            :rules="[{ required: true, message: '请选择短信通知' }]"
          >
            <el-radio-group
              v-model="ruleForm.isNotice"
              @change="isNoticeChange"
            >
              <el-radio
                v-for="(item, i) in isNoticeAttr"
                :key="i"
                :label="item.paramKey"
              >
                {{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <div v-if="isSend">
        <el-row>
          <el-col>
            <el-form-item label="消息内容：" prop="sendMessage">
              <el-input
                v-model="ruleForm.sendMessage"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="发送对象："
              prop="sendPerson"
              :rules="[{ required: true, message: '请选择发送对象' }]"
            >
              <el-checkbox-group v-model="ruleForm.sendPerson" v-if="batchType == 0">
                <el-checkbox
                  v-for="item in sendPersonAttr"
                  :key="item.paramKey"
                  :label="item.paramKey"
                  >{{ item.paramValue }}
                </el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group v-model="ruleForm.sendPerson" v-else>
                <el-checkbox
                  key="-1"
                  label="-1"
                  >所有单位联络员
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn
        btntype="primary"
        @click.native="updateForm()"
        title="确定"
        v-permission="'audit:enroll:updateBatch'"
      ></butn>
    </div>
  </el-dialog>
</template>
<script>
import vue from "@/main";
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import { updateBatchAudit } from "@/api/enrollment";

export default {
  components: { butn },
  data() {
    return {
      size: "small",
      ruleForm: {
        auditSchedule: "2",
        auditContent: "",
        sendMessage: "",
        noticeType: "0",
        isNotice: true,
        sendPerson: []
      },
      detailTitle: "报名审核",
      dialogVisible: false,
      isUnPass: false,
      isSend: true,
      auditScheduleAttr: [],
      sendPersonAttr: [],
      noticeTypeAttr: [],
      isNoticeAttr: [
        { paramValue: "否", paramKey: false },
        { paramValue: "是", paramKey: true }
      ],
      rules: [],
      commonText: "h您好，s的c报名审核",
      tPass: "已通过，请及时做好学员通知工作。",
      tFail: "未通过，原因：（驳回原因），请按要求调整后再次报名。",
      thisItem: {},
      batchType: 0,
    };
  },
  methods: {
    auditScheduleChange() {
      if (this.batchType == 1) {
        if (this.ruleForm.auditSchedule === "2") {
          this.ruleForm.sendMessage = "｛联络员姓名｝您好，{报名部门名称}的{班级名称，不含班级简称}报名审核已通过，请及时做好学员通知工作。"
        } else if (this.ruleForm.auditSchedule === "1") {
          this.ruleForm.sendMessage = "｛联络员姓名｝您好，{报名部门名称}的{班级名称，不含班级简称}报名审核未通过，原因：{驳回原因}，请按要求调整后再次报名。"
        }
      } else {
        const item = this.thisItem;
        const text = this.commonText
          .replace("h", item.auditUserName)
          .replace("s", item.auditDeptName)
          .replace("c", this.className);
        if (this.ruleForm.auditSchedule === "1") {
          this.isUnPass = true;
          this.ruleForm.sendMessage = text + this.tFail;
        } else if (this.ruleForm.auditSchedule === "2") {
          this.isUnPass = false;
          this.ruleForm.auditContent = "";
          this.ruleForm.sendMessage = text + this.tPass;
        }
      }
    },
    isNoticeChange() {
      if (this.ruleForm.isNotice) {
        this.isSend = true;
      } else {
        this.isSend = false;
        this.ruleForm.sendMessage = "";
        this.ruleForm.sendPerson = [];
        this.ruleForm.noticeType = "";
      }
      this.auditScheduleChange();
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.auditScheduleAttr = res.data["AUDIT_SCHEDULE"].slice(1, 3);
        this.noticeTypeAttr = res.data["NOTICE_TYPE"];
      });
    },
    // 关闭
    closeFrom() {
      this.dialogVisible = false;
      // 点击取消 数据重置
      this.sendPersonAttr = [];
      this.isUnPass = false;
      this.isNotice = true;
      this.isSend = true;
      this.$refs["rForm"].resetFields();
    },
    // 确定
    updateForm() {
      this.$refs["rForm"].validate(valid => {
        if (valid) {
          this.ruleForm.sendMessage =
            this.ruleForm.sendMessage.replace("（驳回原因）", this.ruleForm.auditContent);
          let params = {};
          let auditUserList = [];
          if (this.batchType == 0) {
            auditUserList = [this.thisItem].map(ele => ({
              ...ele,
              sendMessage: this.ruleForm.sendMessage,
              sendPerson:  this.ruleForm.sendPerson
            }));
          } else {
            // 发送对象sendPerson：暂时只有一个
            auditUserList = this.thisItem.map(ele => ({
              ...ele,
              sendMessage: this.ruleForm.sendMessage = this.commonText.replace("h", ele.auditUserName).replace("s", ele.auditDeptName).replace("c", this.className) + (this.ruleForm.auditSchedule == '2' ? this.tPass : this.tFail),
              sendPerson:  [ele.auditUserId]
            }));
          }
          params = Object.assign({}, this.ruleForm);
          delete params.sendMessage;
          delete params.sendPerson;
          params.classAuditHistoryVoList = auditUserList;
          updateBatchAudit(params).then(res => {
            if (res.code === 0) {
              this.$message.success(res.msg);
              this.$emit("refreshData");
            }
          });
          this.closeFrom();
        }
      });
    }
  },
  created() {
    let _this = this;
    _this.getSysParamByTypes(["AUDIT_SCHEDULE", "NOTICE_TYPE"]);
    vue.$on("ShowAuditUser", function(item, className, batch) {
      _this.dialogVisible = true;
      _this.className = className;
      // 是否轮训班
      _this.ruleForm.isRotationClass = true;
      _this.batchType = batch;
      if (_this.batchType == 0) {
        _this.sendPersonAttr = [
          {
            paramValue: item.auditUserName,
            paramKey: item.auditUserId
          }
        ];
        _this.ruleForm.sendMessage =
          _this.commonText
            .replace("h", item.auditUserName)
            .replace("s", item.auditDeptName)
            .replace("c", _this.className) + _this.tPass;
        _this.thisItem = item;
      } else {
        _this.thisItem = item;
        _this.ruleForm.sendPerson = ['-1'];
        _this.ruleForm.sendMessage = "｛联络员姓名｝您好，{报名部门名称}的{班级名称，不含班级简称}报名审核已通过，请及时做好学员通知工作。"
      }
    });
  },
  beforeDestroy() {
    vue.$off("ShowAuditUser");
  },
};
</script>
